import { render, staticRenderFns } from "./03-08-happy-goddess-festival.vue?vue&type=template&id=205387b7&scoped=true&"
import script from "./03-08-happy-goddess-festival.vue?vue&type=script&lang=js&"
export * from "./03-08-happy-goddess-festival.vue?vue&type=script&lang=js&"
import style0 from "./03-08-happy-goddess-festival.vue?vue&type=style&index=0&id=205387b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205387b7",
  null
  
)

export default component.exports